import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { GenerateFacebookAuthUrl } from './__generated__/GenerateFacebookAuthUrl';
import { GenerateGoogleAuthUrl } from './__generated__/GenerateGoogleAuthUrl';

export const GENERATE_FACEBOOK_AUTH_URL_QUERY = gql`
  query GenerateFacebookAuthUrl {
    generateFacebookAuthUrl
  }
`;

export const GENERATE_GOOGLE_AUTH_URL_QUERY = gql`
  query GenerateGoogleAuthUrl {
    generateGoogleAuthUrl
  }
`;

export const useGenerateFacebookAuthUrlQuery = () => {
  return useLazyQuery<GenerateFacebookAuthUrl>(GENERATE_FACEBOOK_AUTH_URL_QUERY, {
    client: kmsClient
  });
};

export const useGenerateGoogleAuthUrlQuery = () => {
  return useLazyQuery<GenerateGoogleAuthUrl>(GENERATE_GOOGLE_AUTH_URL_QUERY, {
    client: kmsClient
  });
};
